import { defineMessages } from "react-intl";

export const messages = defineMessages({
    heading: {
        id: "wac.confirmation.codingAgentChoice.heading",
        defaultMessage: "Which coding agents do you use?",
        description:
            "Heading for the screen that asks new Jira users which 3P coding agents they use."
    },
    description: {
        id: "wac.confirmation.codingAgentChoice.description",
        defaultMessage: "We'll tailor your setup to the tools your team uses.",
        description: "Sub-heading explaining the purpose of the selection."
    },
    nextButton: {
        id: "wac.confirmation.codingAgentChoice.next",
        defaultMessage: "Next",
        description: "Label for the primary CTA that confirms the selection."
    },
    githubCopilot: {
        id: "wac.confirmation.codingAgentChoice.option.githubCopilot",
        defaultMessage: "GitHub Copilot for Jira",
        description: "Coding agent option: GitHub Copilot for Jira."
    },
    claude: {
        id: "wac.confirmation.codingAgentChoice.option.claude",
        defaultMessage: "Claude",
        description: "Coding agent option: Claude (Anthropic)."
    },
    cursor: {
        id: "wac.confirmation.codingAgentChoice.option.cursor",
        defaultMessage: "Cursor",
        description: "Coding agent option: Cursor."
    },
    codex: {
        id: "wac.confirmation.codingAgentChoice.option.codex",
        defaultMessage: "Codex",
        description: "Coding agent option: Codex (OpenAI)."
    },
    githubCopilotLogoAlt: {
        id: "wac.confirmation.codingAgentChoice.option.githubCopilot.logoAlt",
        defaultMessage: "GitHub Copilot logo",
        description: "Alt text for the GitHub Copilot agent logo."
    },
    claudeLogoAlt: {
        id: "wac.confirmation.codingAgentChoice.option.claude.logoAlt",
        defaultMessage: "Claude logo",
        description: "Alt text for the Claude agent logo."
    },
    cursorLogoAlt: {
        id: "wac.confirmation.codingAgentChoice.option.cursor.logoAlt",
        defaultMessage: "Cursor logo",
        description: "Alt text for the Cursor agent logo."
    },
    codexLogoAlt: {
        id: "wac.confirmation.codingAgentChoice.option.codex.logoAlt",
        defaultMessage: "Codex logo",
        description: "Alt text for the Codex agent logo."
    },
    checkboxLabel: {
        id: "wac.confirmation.codingAgentChoice.option.checkbox.label",
        defaultMessage: "Select {agent}",
        description:
            "Accessible label for the checkbox on each coding agent option card."
    }
});
